import React, { useEffect, useState } from "react";
import VideoCataloguesList from "./VideoCataloguesList";
import { searchVideos } from "../../api/videos/videosApi";
import { Organization, Video, VideoCataloguesDto } from "../common/ObjectTypes";
import { useNavigate } from "react-router-dom";
import { MoonLoader } from "react-spinners";
import {
  searchVideoCatalogues,
  getVideoCatalogues,
} from "../../api/videoCatalogues.tsx/videoCataloguesApi";
import { PHOTO_URL } from "../../base";
import { getOrganizations } from "../../api/organizations/organizationsApi";

type VideoCataloguesPageProps = {
  selectVideoCataloguesPage: boolean;
};

const VideoCataloguesPage: React.FC<VideoCataloguesPageProps> = ({
  selectVideoCataloguesPage,
}) => {
  // const [videoSearchQuery, setVideoSearchQuery] = useState({})
  const navigate = useNavigate();

  const [videoCatalogues, setVideoCatalogues] = useState<VideoCataloguesDto[]>(
    []
  );
  const [filteredVideoCatalogues, setFilteredVideoCataloguess] = useState<
    VideoCataloguesDto[]
  >([]);
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [reloadPage, setReloadPage] = useState(true);
  const [query, setQuery] = useState<string>("");
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [recordStart, setRecordStart] = useState(1);
  const [recordEnd, setRecordEnd] = useState(25);
  const pageSize = selectVideoCataloguesPage ? 10 : 25;
  const photoUrl = PHOTO_URL || "placeholder.jpg";
  const [searchQuery, setSearchQuery] = useState({
    name: "",
    pageNumber: 1,
    pageSize: pageSize,
    // selectVideoCataloguesPage ? pageSize : 25,
  });

  useEffect(() => {
    const loadVideoCatalogues = async () => {
      try {
        const temp = await searchVideoCatalogues(searchQuery);
        setVideoCatalogues(temp.results);
        setFilteredVideoCataloguess(temp.results);
        setPageCount(Math.ceil(temp.totalCount / pageSize));
        setTotalCount(temp.totalCount);
        const start = (searchQuery.pageNumber - 1) * searchQuery.pageSize + 1;
        const end = Math.min(start + temp.results.length - 1, temp.totalCount);
        setRecordStart(start);
        if (temp.totalCount === 0) {
          setRecordStart(0);
          setRecordEnd(0);
        } else if (temp.totalCount >= pageSize) {
          setRecordEnd(end);
        } else {
          setRecordEnd(temp.totalCount);
        }
        loadOrganizations();
        setPageLoaded(true);
        setReloadPage(false);
      } catch (error) {
        console.log(error);
      }
    };

    const loadOrganizations = async () => {
      try {
        const temp = await getOrganizations();
        setOrganizations(temp);
        setPageLoaded(true);
      } catch (err) {
        console.log(err);
      }
    };

    loadVideoCatalogues();
  }, [searchQuery, reloadPage]);

  const handlePageClick = (selectedItem: { selected: number }) => {
    setSearchQuery((prevQuery) => ({
      ...prevQuery,
      pageNumber: selectedItem.selected + 1,
    }));
    setReloadPage(true);
  };

  // HELPER FUNCTION TO SORT
  function ascName(videoA: any, videoB: any) {
    // Use toUpperCase() to ignore character casing
    const vA = videoA.name.toUpperCase();
    const vB = videoB.name.toUpperCase();

    let comparison = 0;
    if (vA < vB) {
      comparison = 1;
    } else if (vA > vB) {
      comparison = -1;
    }
    return comparison;
  }
  // HELPER FUNCTION TO SORT
  function descName(videoA: any, videoB: any) {
    // Use toUpperCase() to ignore character casing
    const vA = videoA.name.toUpperCase();
    const vB = videoB.name.toUpperCase();

    let comparison = 0;
    if (vA > vB) {
      comparison = 1;
    } else if (vA < vB) {
      comparison = -1;
    }
    return comparison;
  }

  // // TEMPORARY HELPER FUNCTION TO SORT
  function ascDate(videoA: any, videoB: any) {
    // Use toUpperCase() to ignore character casing
    const vA = videoA.lastEdited;
    const vB = videoB.lastEdited;

    let comparison = 0;
    if (vA < vB) {
      comparison = 1;
    } else if (vA > vB) {
      comparison = -1;
    }
    return comparison;
  }
  // TEMPORARY HELPER FUNCTION TO SORT
  function descDate(videoA: any, videoB: any) {
    // Use toUpperCase() to ignore character casing
    const vA = videoA.lastEdited;
    const vB = videoB.lastEdited;

    let comparison = 0;
    if (vA > vB) {
      comparison = 1;
    } else if (vA < vB) {
      comparison = -1;
    }
    return comparison;
  }

  // TEMPORARY HELPER FUNCTION TO SORT
  function ascPublished(videoA: any, videoB: any) {
    // Use toUpperCase() to ignore character casing
    const vA = videoA.published;
    const vB = videoB.published;

    let comparison = 0;
    if (vA < vB) {
      comparison = 1;
    } else if (vA > vB) {
      comparison = -1;
    }
    return comparison;
  }
  // TEMPORARY HELPER FUNCTION TO SORT
  function descPublished(videoA: any, videoB: any) {
    // Use toUpperCase() to ignore character casing
    const vA_published = videoA.published;
    const vB_published = videoB.published;

    let comparison = 0;
    if (vA_published > vB_published) {
      comparison = 1;
    } else {
      comparison = -1;
    }
    return comparison;
  }

  const sortVideoCataloguesName = (key: string, order: boolean) => {
    let tempVideos = [...videoCatalogues].sort(order ? ascName : descName);
    setFilteredVideoCataloguess(tempVideos);
  };

  const sortVideosDate = (key: string, order: boolean) => {
    let tempVideos = [...videoCatalogues].sort(order ? ascDate : descDate);
    setFilteredVideoCataloguess(tempVideos);
  };

  const sortVideosPublished = (key: string, order: boolean) => {
    let tempVideos = [...videoCatalogues].sort(
      order ? ascPublished : descPublished
    );
    setFilteredVideoCataloguess(tempVideos);
  };

  const handleChangeFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value);
  };

  const handleAddVideoCatalogue = () => {
    navigate("/videoCatalogue/add");
  };

  const handleSelectVideoCatalogue = (id: number) => {
    navigate("/videoCatalogue/" + id + "/edit");
  };

  const handleSearch = async () => {
    try {
      setSearchQuery((prevQuery) => ({
        ...prevQuery,
        name: query,
      }));
      //   setFilteredVideos(temp.results);
      setReloadPage(true);
    } catch (error) {
      console.log(error);
    }
  };
  return !pageLoaded || reloadPage ? (
    <div className="flex justify-center content-center items-center">
      <MoonLoader color="#9EB45B" />
    </div>
  ) : (
    <VideoCataloguesList
      videoResults={filteredVideoCatalogues}
      sortVideosName={sortVideoCataloguesName}
      sortVideosDate={sortVideosDate}
      searchQuery={searchQuery}
      sortVideosPublished={sortVideosPublished}
      onChangeFilter={handleChangeFilter}
      onSearch={handleSearch}
      onSelectVideo={handleSelectVideoCatalogue}
      subStr={query}
      pageCount={pageCount}
      pageSize={pageSize}
      totalCount={totalCount}
      handlePageClick={handlePageClick}
      reloadPage={reloadPage}
      recordStart={recordStart}
      recordEnd={recordEnd}
      selectVideoCataloguesPage={selectVideoCataloguesPage}
      onAddCatalogue={handleAddVideoCatalogue}
      photoUrl={photoUrl}
      organizations={organizations}
    />
  );
};

export default VideoCataloguesPage;
